import { Dropdown } from 'antd';
import { MenuProps } from 'antd/lib';
import { TURN_SORT_BY } from 'features/turn/services/constants';
import { turnManualActions } from 'features/turn/services/reducers';
import { turnManualSelectors } from 'features/turn/services/selectors';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import ic_sort from './ic-sort-by.svg';
import ic_refresh from './ic-refresh.svg';
import { turnManualAPIActions } from 'features/turn/services/actions';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import Box from 'components/Box';
import Text from 'components/Text';
import ListServierTurnButton from './ListServierTurnButton';
import colorTheme from 'constants/color';
import { ListFilter, RotateCw } from 'lucide-react';

const TurnSort = () => {
  const allSetting = shopSelectors.data.allSetting();
  const dispatch = useAppDispatch();
  const sort = turnManualSelectors.sort();
  const setLoadingPage = useSetLoadingPage();
  const setSort = (value: string) => dispatch(turnManualActions.setSort(value as TURN_SORT_BY));
  const onClickMenuItem = (key: string) => {
    if (sort == key) {
      return;
    }
    setSort(key);
  };

  const filterItems: MenuProps['items'] = [
    {
      key: TURN_SORT_BY.CLOCK_IN,
      label: (
        <a
          onClick={(e) => {
            e.preventDefault();
            onClickMenuItem(TURN_SORT_BY.CLOCK_IN);
          }}
        >
          Clock In
        </a>
      ),
    },
    {
      key: TURN_SORT_BY.TURN,
      label: (
        <a
          onClick={(e) => {
            e.preventDefault();
            onClickMenuItem(TURN_SORT_BY.TURN);
          }}
        >
          Turn
        </a>
      ),
    },
  ];

  const onRefresh = () => {
    setLoadingPage(true);
    dispatch(turnManualAPIActions.init());
    setTimeout(() => {
      setLoadingPage(false);
    }, 500);
  };

  return (
    <Box display='flex' alignItems='center' gap='3' pl='5'>
      <Dropdown
        menu={{
          items: filterItems,
          selectable: true,
          selectedKeys: sort ? [sort] : [],
        }}
        trigger={['click']}
        rootClassName='styled-dropdown'
      >
        <a
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <ActionButton>
            {/* <img src={ic_sort} alt='sort' /> */}
            <ListFilter strokeWidth={2.5} color={colorTheme.teal_5}/>
            <Text variant='H6' color='v2_other_3'>
              Sort By
            </Text>
          </ActionButton>
        </a>
      </Dropdown>
      <ActionButton
        className='refresh-icon'
        type='button'
        onClick={(e: any) => [e.stopPropagation(), e.preventDefault(), onRefresh()]}
      >
        {/* <img src={ic_refresh} alt='refresh' /> */}
        <RotateCw strokeWidth={2.5} color={colorTheme.coral_5}/>
        <Text variant='H6'>
          Refresh
        </Text>
      </ActionButton>
      <ListServierTurnButton />
    </Box>
  );
};

export default TurnSort;

const ActionButton = styled.button`
  display: flex;
  height: 56px;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  background: ${colorTheme.ink_1};
  border: 1px solid ${colorTheme.ink_2};
  &:hover,
  &:active {
    opacity: 0.8;
    background: ${colorTheme.ink_2};
    cursor: pointer;
  }

  .H6 {
    font-family: Poppins;
    font-weight: 600;
    color: ${colorTheme.ink_7};
  }
`;

const Filter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  span {
    padding-left: 4px;
  }
`;
